import { Page, Spinner, Text } from "@shopify/polaris";

/**
 * RouteLoader Component
 * 
 * Provides a consistent loading state for lazy-loaded routes.
 * Uses Polaris design system components for visual consistency.
 * 
 * Usage: Fallback component for React.Suspense boundaries
 */
export default function RouteLoader() {
  return (
    <Page>
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        flexDirection: "column",
        gap: "16px"
      }}>
        <Spinner size="large" />
        <Text variant="bodyMd" tone="subdued">
          Loading...
        </Text>
      </div>
    </Page>
  );
}